import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, eur } from "../lib/api";
import { Bell, CalendarClock, Wallet, X } from "lucide-react";

export default function NotificationBell() {
  const [data, setData] = useState({ count: 0, haccp: [], budget: null });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
    load();
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const go = (path) => { setOpen(false); navigate(path); };

  const dismiss = async (e, key) => {
    e.stopPropagation();
    setData((d) => {
      const haccp = d.haccp.filter((h) => h.key !== key);
      const budget = d.budget && d.budget.key === key ? null : d.budget;
      return { haccp, budget, count: haccp.length + (budget ? 1 : 0) };
    });
    try { await api.post("/notifications/dismiss", { key }); } catch (err) {}
  };

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="notification-bell"
        onClick={() => setOpen((o) => !o)}
        className="relative flex h-9 w-9 items-center justify-center rounded-full text-white transition-colors hover:bg-white/10 md:text-navy md:hover:bg-slate-100"
      >
        <Bell className="h-5 w-5" />
        {data.count > 0 && (
          <span data-testid="notification-count" className="absolute -right-0.5 -top-0.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1 text-[11px] font-bold text-white">
            {data.count}
          </span>
        )}
      </button>

      {open && (
        <div data-testid="notification-dropdown" className="animate-slide-up absolute right-0 z-50 mt-2 w-80 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-xl">
          <div className="border-b border-slate-100 px-4 py-3 font-head font-semibold text-navy">Avvisi</div>
          <div className="max-h-96 overflow-y-auto">
            {data.count === 0 ? (
              <div className="px-4 py-8 text-center text-sm text-slate-400">Nessun avviso. Tutto sotto controllo.</div>
            ) : (
              <>
                {data.budget && (
                  <div data-testid="notif-budget" className="flex items-start gap-2 border-b border-slate-50 px-4 py-3 hover:bg-slate-50">
                    <button onClick={() => go("/setup")} className="flex flex-1 items-start gap-3 text-left">
                      <Wallet className={`mt-0.5 h-5 w-5 shrink-0 ${data.budget.pct >= 100 ? "text-red-500" : "text-amber-500"}`} />
                      <div>
                        <div className="text-sm font-semibold text-navy">Budget {data.budget.month} al {data.budget.pct}%</div>
                        <div className="text-xs text-slate-500">Speso {eur(data.budget.spent)} di {eur(data.budget.budget)}</div>
                      </div>
                    </button>
                    <button data-testid="dismiss-budget" onClick={(e) => dismiss(e, data.budget.key)} className="rounded p-1 text-slate-300 hover:bg-slate-200 hover:text-slate-600"><X className="h-4 w-4" /></button>
                  </div>
                )}
                {data.haccp.map((h, i) => (
                  <div key={i} data-testid={`notif-haccp-${i}`} className="flex items-start gap-2 border-b border-slate-50 px-4 py-3 hover:bg-slate-50">
                    <button onClick={() => go("/scadenze")} className="flex flex-1 items-start gap-3 text-left">
                      <CalendarClock className={`mt-0.5 h-5 w-5 shrink-0 ${h.days < 0 ? "text-red-500" : "text-amber-500"}`} />
                      <div>
                        <div className="text-sm font-semibold text-navy">{h.product}</div>
                        <div className="text-xs text-slate-500">{h.days < 0 ? `Scaduto da ${Math.abs(h.days)}g` : h.days === 0 ? "Scade oggi" : `Scade tra ${h.days}g`}</div>
                      </div>
                    </button>
                    <button data-testid={`dismiss-haccp-${i}`} onClick={(e) => dismiss(e, h.key)} className="rounded p-1 text-slate-300 hover:bg-slate-200 hover:text-slate-600"><X className="h-4 w-4" /></button>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
